module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0, false, false)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vipnotify"
  }, [_c('h2', [_vm._v("VIP新入患者告知书")]), _vm._v(" "), _c('h3', [_vm._v("尊敬的VIP客户您好：")]), _vm._v(" "), _c('p', {
    staticClass: "dection"
  }, [_vm._v("很荣幸我们有机会能为您提供服务， 在此期间您从办理开始到VIP结束都会由我们为您提供医疗上的帮助，我们可以微信联系，也可以电话联系，根据您的服务需求不同我们提供不同的电话号码：")]), _vm._v(" "), _c('p', {
    staticClass: "border"
  }, [_vm._v("预约就诊："), _c('a', {
    staticStyle: {
      "color": "#4ba7e8"
    },
    attrs: {
      "href": "tel:02865191516"
    }
  }, [_vm._v("028-65191516")])]), _vm._v(" "), _c('p', {
    staticClass: "border"
  }, [_vm._v("预约订餐："), _c('a', {
    staticStyle: {
      "color": "#4ba7e8"
    },
    attrs: {
      "href": "tel:02865191516"
    }
  }, [_vm._v("028-65191516")])]), _vm._v(" "), _c('p', {
    staticClass: "border"
  }, [_vm._v("预约动感单车："), _c('a', {
    staticStyle: {
      "color": "#4ba7e8"
    },
    attrs: {
      "href": "tel:02865191516"
    }
  }, [_vm._v("028-65191516")])]), _vm._v(" "), _c('p', {
    staticClass: "border"
  }, [_vm._v("预约中医理疗："), _c('a', {
    staticStyle: {
      "color": "#4ba7e8"
    },
    attrs: {
      "href": "tel:02865191521"
    }
  }, [_vm._v("028-65191521")])]), _vm._v(" "), _c('h3', [_vm._v("注意")]), _vm._v(" "), _c('p', {
    staticClass: "border"
  }, [_vm._v("1、预约方式仅提供电话预约，不提供微信预约以及口头预约，最后以您收到预约短信为准。")]), _vm._v(" "), _c('p', {
    staticClass: "border"
  }, [_vm._v("2、白天微信咨询医疗管家，因为工作原因将没办法随时回答到您的问题，请理解，若需要及时解决的疑问或者问题，08：00--17：00请致电028--65191516或者18109063791，17：00后请致电18109063791（24小时值班电话）如果当时没有接到您的电话请发送短息给我，我将第一时间给您回复电话。")]), _vm._v(" "), _c('h3', [_vm._v("VIP期间可以享受到的服务")]), _vm._v(" "), _c('p', {
    staticClass: "border"
  }, [_vm._v("1、\t预约就诊：预约请拨打预约电话，如果当日需要行B超检查请根据您的预约时间提前20/30分钟（B超结果当时拿报告）到医院，如果需要行激素检查则提前60分钟到医院（激素结果需要1个小时出报告），这样我们就能有效保证您的就诊时间。预约时间：至少就诊前一天08:00-17:00。")]), _vm._v(" "), _c('p', {
    staticClass: "border"
  }, [_vm._v("2、\t提供就诊日早、午餐：仅提供就诊当天，需要在当天11:00之前预定，超过时间将无法完成订制；仅提供夫妻二人；早餐需要到4楼前台领取早餐劵，午餐如果没有通过电话订餐请到4楼前台订餐，请与客服联系。早餐：粥、豆浆、包子、馒头、鸡蛋、蛋糕、面包。午餐：营养餐（炖汤、水果）。")]), _vm._v(" "), _c('p', {
    staticClass: "border"
  }, [_vm._v("3、\tNSP运动营养俱乐部：俱乐部提供单车运动/备孕瑜伽:（IVF---42次含两次私教课程,FET---10次含两次私教课程,IUI---18次含两次私教课程）运动时间在周一至周六，建议每周2-3次即可，月经期停止一切运动。营养科老师会通过身体监测后，根据您的身体情况给您制定符合周期要求的健康食谱并制定健康的生活计划。心理医师会根据您的需求就诊，通过与心理师沟通减缓心理压力。")]), _vm._v(" "), _c('p', {
    staticClass: "border"
  }, [_vm._v("4、\t中医科：在VIP期间，中医科老师会根据个体情况做周期理疗调理计划，目的是为了您拥有更好、更健康的状态孕育宝宝。主要涉及理疗为主，比如：针灸、艾灸、经皮贴、姜疗、艾柱、仪器设备等。若需要中医药物调理则需要自费。")]), _vm._v(" "), _c('p', {
    staticClass: "border"
  }, [_vm._v("5、候诊：在4楼有10余间候诊室，里面配有长短沙发、按摩椅，主要是方便您在等候过程中的隐私保护，中午时间您可以在候诊室内休息。休闲厅：里面可以点播电影或者网络电视，如果您有需要请直接与客服联系。休闲厅里面有各种类型的书籍在这里您可以随便阅读，借阅离院请到客服处登记。对于医院的使用配件比如靠枕之类的物品都是不外借的。任何的物品遗失或是损坏都是需要原价赔偿的，请文明使用。")]), _vm._v(" "), _c('h3', [_vm._v("您在周期期间需要遵从的义务")]), _vm._v(" "), _c('p', {
    staticClass: "border"
  }, [_vm._v("1、根据医师要求的时间就诊，如果需要修改时间需要与您的管家或者医师取得同意，不得私自更改时间。")]), _vm._v(" "), _c('p', {
    staticClass: "border"
  }, [_vm._v("2、就诊期间要求是真实姓名，真实身份，不得以任何形式的冒名顶替。")]), _vm._v(" "), _c('p', {
    staticClass: "border"
  }, [_vm._v("3、您需要准备好两种证件：双方的身份证、双方的结婚证，要求证件内容相吻合。证件的使用时间是：办理VIP的时候、降调节/进入周期的时候、进入手术室的时候（在进入手术的时候不得以任何原因为缘由不携带证件，或者证件上的人像与电脑采集的人像或者是现场的人像不符合，否则手术室将拒绝做取卵移植手术，后果自己承担）。")]), _vm._v(" "), _c('p', {
    staticClass: "border"
  }, [_vm._v("4、您需要录入的信息：双方的合影、双方有效证件、双方指纹（在一楼前台，凭双方有效证件录入电脑）这样的目的是保证了您的权益。")]), _vm._v(" "), _c('p', {
    staticClass: "border"
  }, [_vm._v("5、保持电话通畅，医院VIP的座机电话常规是以6519或6503开头。如果您更改电话号码请本人持有效证件到院及时更换，避免因失联造成不必要的损失。")]), _vm._v(" "), _c('p', {
    staticClass: "border"
  }, [_vm._v("6、VIP一旦失效后，在该期间赠送的项目比如：单车、瑜伽、中医理疗等项目也一同失效，不做下周期累计。")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4bb69987","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/project/vipnotifyProject/vipnotify.vue
// module id = q6Ya
// module chunks = 6